function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M479.6,331.852c-52.7-36.2-122.6-52.8-147.4-57.8l-12.3-102.1c-0.4-22.9-19.2-41.4-42.2-41.4c-22.7,0-41,17.5-42.1,40 c0,0.4-0.1,0.8-0.1,1.2v60.5l-1,147.2l-15.5-11.9c-19-16.6-63.8-37-99.7,2.4c-3.9,4.3-4.3,10.6-0.9,15.3 c1,1.4,25.2,35.3,63.7,71.8c4.9,4.7,12.7,4.4,17.3-0.5s4.4-12.7-0.5-17.3c-25.5-24.2-44.7-47.5-54.1-59.6 c26.5-19.8,55,3.5,58.3,6.5c0.2,0.2,0.4,0.3,0.6,0.5l35.4,27.3c3.7,2.8,8.7,3.4,12.8,1.3c4.2-2,6.8-6.3,6.9-10.9l1.2-172v-59.9 c0-0.1,0-0.2,0-0.4c0.3-9.6,8-17.1,17.7-17.1s17.7,7.9,17.7,17.7c0,0.5,0,1,0.1,1.5l13.4,111.7c0.6,5.4,4.8,9.7,10.1,10.6 c0.8,0.1,83.4,14.3,142.4,52.7c2.2,14.2,7.2,56.8-2.7,96c-1.7,6.6,2.3,13.2,8.9,14.9c1,0.3,2,0.4,3,0.4c5.5,0,10.5-3.7,11.9-9.3 c13.4-53.2,2.6-109.3,2.2-111.6C484,336.452,482.2,333.652,479.6,331.852z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.2,38.752c-57.4,0-104.2,46.7-104.2,104.2c0,57.4,46.7,104.2,104.2,104.2c51.8,0,95.1-37.1,103-88.2 c0.8-5.3,1.2-10.7,1.2-16c0-6.8-5.5-12.3-12.3-12.3c-6.8,0-12.3,5.5-12.3,12.3c0,4.1-0.3,8.2-0.9,12.3 c-5.9,38.4-39.8,67.4-78.7,67.4c-43.9,0-79.7-35.7-79.7-79.7s35.7-79.7,79.7-79.7c23.6,0,45.9,10.5,60.9,28.4l-58.5,58.1l-33-33.2 c-4.8-4.8-12.5-4.8-17.3-0.1c-4.8,4.8-4.8,12.5-0.1,17.3l41.6,41.9c2.3,2.3,5.4,3.6,8.7,3.6l0,0c3.2,0,6.3-1.3,8.6-3.6l126.7-126 c4.8-4.8,4.8-12.5,0.1-17.3c-4.8-4.8-12.5-4.8-17.3-0.1l-42.1,41.9C162.9,51.852,134.4,38.752,104.2,38.752z"
}));

var SvgIconLivePolls = function SvgIconLivePolls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489.191 489.191",
    style: {
      enableBackground: "new 0 0 489.191 489.191"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLivePolls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_live-polls.0bb9a251.svg";
export { ForwardRef as ReactComponent };